import {
  Grid,
  Typography,
  Button,
  CircularProgress,
  DialogTitle,
  Dialog,
  DialogContentText,
  DialogContent,
  IconButton,
} from "@mui/material";
import HotlineMessage from "./HotlineMessage";
import { BenzieGiftsPromo } from "./BenzieGifts";
import { getPublicMessages } from "../network/api";
import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

function SimpleDialog(props) {
  const { onClose, open } = props;

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Gratitude Circle Hotline
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <p>
            We all have some gratitude to express. Workers on the frontline of
            the COVID-19 pandemic deserve thanks for their incredible and
            valiant efforts.
          </p>
          Hotline callers can:
          <ol>
            <li>Listen to the Gratitude Message of the Day</li>
            <li>Leave a voice recording thanking a frontline worker</li>
            <li>
              Send a text message expressing your gratitude for whatever or
              whomever you choose
            </li>
          </ol>
          <p>
            Submitted voicemails and SMS messages will be reviewed and posted
            publicly on this website. Call today!&nbsp;&nbsp;
            <a href="tel:+19793105162">+1 (979) 310 5162</a>
          </p>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}

const centeredGridItems = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

function Body() {
  const [messages, setMessages] = useState([]);
  const [nextPage, setNextPage] = useState(1);
  const [reachedEnd, setReachedEnd] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const loadMoreMessages = async (page) => {
    setIsLoading(true);
    try {
      const m = await getPublicMessages(page);
      if (m.res.length === 0) setReachedEnd(true);
      else {
        setMessages((prev) => [...prev, ...m.res]);
        // setMessages(m.res.concat(m.res).concat(m.res).concat(m.res))
        setNextPage((prev) => prev + 1);
      }
    } catch {}
    setIsLoading(false);
  };
  useEffect(() => {
    if (nextPage === 1) loadMoreMessages(nextPage);
  }, [nextPage]);

  return (
    <Grid container spacing={3}>
      <Grid item container sm={12} lg={10}>
        <Grid item container xs={12} marginTop={5} marginBottom={3} spacing={3}>
          <Grid item sm={12} md={6} sx={centeredGridItems}>
            <Typography variant="h4" component="span">
              Official line:&nbsp;
            </Typography>
            <Typography variant="h4" component="a" href="tel:+19793105162">
              +1 (979) 310 5162
            </Typography>
          </Grid>
          <Grid item sm={6} md={3} sx={centeredGridItems}>
            <Button
              variant="contained"
              size="large"
              onClick={() => setIsDialogOpen(true)}
            >
              What is this hotline?
            </Button>
            <SimpleDialog
              open={isDialogOpen}
              onClose={() => setIsDialogOpen(false)}
            />
          </Grid>
          <Grid item sm={6} md={3} sx={centeredGridItems}>
            <Button variant="contained" size="large" href="tel:+19793105162">
              Call now
            </Button>
          </Grid>
        </Grid>
        <Grid
          item
          container
          xs={12}
          spacing={3}
          sx={{
            height: "700px",
            overflow: "auto",
            /*border: '1px solid #e2e2e3', borderRadius: 4,*/ mt: 1,
          }}
        >
          {messages.map((msg) => (
            <Grid item lg={4} md={6} sm={12} key={msg.created} sx={{ px: 3 }}>
              <HotlineMessage msg={msg} />
            </Grid>
          ))}
          {isLoading && (
            <Grid item xs={12} sx={centeredGridItems}>
              <CircularProgress />
            </Grid>
          )}
          <Grid item xs={12} sx={centeredGridItems}>
            <Button
              variant="contained"
              size="large"
              onClick={() => loadMoreMessages(nextPage)}
              disabled={reachedEnd}
            >
              {reachedEnd ? "No more messages" : "See more messages"}
            </Button>
          </Grid>
        </Grid>
      </Grid>
      {/* <Box sx={{ height: "800px", overflow: "auto" }}>
      </Box> */}
      <Grid item sm={12} lg={2}>
        <BenzieGiftsPromo />
      </Grid>
    </Grid>
  );
}

export default Body;
